import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { icons } from '../../assets/icons'
import { setActiveModalInstruction } from '../../store/slices/menu/menu'
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export const ModalInstructionHome = () => {
	const dispatch = useDispatch()
	const { menu: { activeModalInstruction, menuIntroduction } } = useSelector(state => state)
	const [selectTopic, setSelectTopic] = useState(-1)

	const exitExperence = () => {
		dispatch(setActiveModalInstruction(false))
	}

	const pagination = {
		clickable: true,
		renderBullet: function (index, className) {
			return '<span class="' + className + '"></span>';
		},
	};
	return (
		<>
			<div className={`fixed z-50 h-full w-full ${!activeModalInstruction && 'hidden'}`}>
				<div className='h-[40px] w-full bg-red_primary px-6 flex items-center justify-between'>
					<div className='w-[170px] h-full flex items-center gap-2'>
						<div className='w-[32px] h-[32px] overflow-hidden rounded-[8px] bg-[#EE7A76]'>
							<img className="w-full h-full object-contain object-bottom" src={icons.chico_oxxo} alt="usuario" />
						</div>
						<div className='flex flex-col w-[calc(100%-32px)] h-full'>
							<div className='w-full h-[16px]'>
								<span className='text-white text-[14px] font-bold'>Juan Torres</span>
							</div>
							<div className='w-full h-[12px]'>
								<span className='text-white text-[10px]'>Juan Torres</span>
							</div>
						</div>
					</div>
					<div className='w-[80px] h-full flex items-center justify-center gap-2'>
						{/* <div onClick={activeInsing} className="h-7 w-7 md:h-9 md:w-9 p-1 md:p-1.5 rounded-3xl bg-[#FFC427] button-menu-action ">
							<img className="h-full w-full object-contain" src={icons.backinsg} alt="insignnias" />
						</div> */}
						<div
							onClick={exitExperence}
							className="h-7 w-7 md:h-9 md:w-9 pl-2 py-1.5 pr-1 md:py-1.5 rounded-3xl bg-[#DA4845] button-menu-action"
						>
							<img className="h-full w-full object-contain" src={icons.exit} alt="exit" />
						</div>
					</div>
				</div>
				<div className='w-full h-[calc(100%-40px)] gradiantBlueClient'>
					<div className='w-full h-[60px] flex gap-5 px-7 overflow-x-scroll hidden-scrooll'>
						{menuIntroduction.map((menu, index) => (
							<div key={`${index}-menuIntro`} className='h-full whitespace-nowrap flex justify-center items-center'>
								<div onClick={() => {
									setSelectTopic(index)
								}} className={`h-10 flex gap-2 justify-center items-center p-4 rounded-full ${selectTopic === index ? "bg-[#0086BF] " : "bg-[#ffffff2e] "}`}>
									<div className="h-5 w-5">
										<img className="h-full w-full object-contain" src={icons.iconhand} alt="hand" />
									</div>
									<div className="flex justify-center items-center">
										<span className="text-[14px] text-white">{menu.title}</span>
									</div>
								</div>
							</div>
						))}
					</div>
					<div className='w-full h-[calc(100%-60px)] py-2 relative'>
						<div className='absolute z-10 h-full w-full flex md:items-center'>
							<div className='h-[240px] md:h-[550px] xl:h-[700px] w-full flex'>
								<div className='halfBoxMenuLeft w-[50%] h-full'></div>
								<div className='halfBoxMenuRight w-[50%] h-full'></div>
							</div>
						</div>
						<div className='absolute z-20 h-full w-full'>
							<Swiper
								effect={'coverflow'}
								grabCursor={true}
								centeredSlides={true}
								slidesPerView={'auto'}
								coverflowEffect={{
									rotate: 50,
									stretch: 0,
									depth: 100,
									modifier: 1,
								}}
								pagination={pagination}
								modules={[EffectCoverflow, Pagination]}
							>
								{selectTopic > -1 && (
									<>
										{menuIntroduction[selectTopic].images.map((iteam, index) => (
											<SwiperSlide key={`${index}-swiper-iteam`}>
												<div className='h-full w-full py-4 flex items-center'>
													<div className='h-[195px] md:h-[350px] w-full overflow-hidden'>
														<div className='w-full h-full bg-white rounded-2xl p-4'>
															<div className='h-full w-full rounded-lg overflow-hidden'>
																<div className='h-[calc(100%-30px)]'>
																	<img className='h-full w-full' src={iteam.images} alt="instructor" />
																</div>
																<div className='h-[30px] w-full bg-black flex justify-center items-center text-center'>
																	<span className='text-white text-[8px] md:text-[14px] font-semibold'>{iteam.text}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</SwiperSlide>
										))}
									</>
								)}
							</Swiper>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
